import { message } from 'antd';
import { status } from 'assets/images';
import {
  ICartPost,
  ICartListResponse,
  ICartReponse,
  CartTVV,
  CartTVVRequest,
  ICartPut,
} from 'interface/cart.interface';
import axiosClient from './axiosClient';
import { IPagination, IPagingResponse } from 'interface/base.interface';
import { IProduct, IProductReponse } from 'interface/product.interface';

const path = 'abe/cart';

const CartApi = {
  get: (params?: IPagination): Promise<ICartListResponse> => {
    return axiosClient.get(`/${path}`, { params });
  },
  getDetail: (id: string): Promise<ICartReponse> => {
    return axiosClient.get(`/${path}/get-detail?id=${id}`);
  },
  post: (data: ICartPost): Promise<any> => {
    return axiosClient.post(`/${path}`, data);
  },
  put: (data: ICartPut): Promise<any> => {
    return axiosClient.put(`/${path}`, data);
  },

  delete: (id: string): Promise<any> => {
    return axiosClient.delete(`/${path}/${id}`);
  },

  getCartProduct: (
    cart_info_id: string,
    params?: IPagination
  ): Promise<IPagingResponse<IProduct>> => {
    return axiosClient.get(
      `/${path}/get-cart-product?cart_info_id=${cart_info_id}`,
      { params }
    );
  },

  inserProductToCart: (data: any): Promise<any> => {
    console.log(data);
    return axiosClient.post(`/${path}/insert-cart-product`, data);
  },

  editInfo: (data: any): Promise<any> => {
    return axiosClient.put(`/${path}`, data);
  },

  getProductOfCartRegister: (
    cart_code: string,
    list_id_cart_register_detail: number[],
    params?: IPagination
  ): Promise<IPagingResponse<IProduct>> => {
    return axiosClient.post(`/${path}-register`, {
      cart_code,
      list_id_cart_register_detail,
    });
  },

  getCartAllocated: (params?: any): Promise<IPagingResponse<any>> => {
    return axiosClient.get(`/${path}/allocated-to-store`, { params });
  },

  getCartCHT: (params?: IPagination) => {
    return axiosClient.get(`/abe/cart-order/cht?shop_id=1000`, { params });
  },

  postCartTVV: (params?: any): Promise<IPagingResponse<any>> => {
    return axiosClient.post(`/abe/cart-register`, params);
  },

  postCartXman: (params?: any): Promise<IPagingResponse<any>> => {
    return axiosClient.post(
      `/abe/cart-register/list-xman-by-cart-code`,
      params
    );
  },

  filterSelectedCartRegister: (params?: any): Promise<IPagingResponse<any>> => {
    return axiosClient.post(
      `/abe/cart-register/filter-selected-cart-register`,
      params
    );
  },

  getFullMinMaxCartOrder: (
    cart_code: string,
    list_tu_xman_code: string[],
    capital_year?: number
  ): Promise<IPagingResponse<any>> => {
    // const encodeListTu = list_tu_xman_code.map((a) =>
    //   encodeURI(JSON.stringify(a))
    // );

    return axiosClient.post(`/abe/cart-order/tvv/get-full-old-min-max`, {
      ...(!list_tu_xman_code.includes('all') &&
        list_tu_xman_code.length != 0 && { list_tu_xman_code }),
      cart_code,
      ...(capital_year ? { capital_year } : {}),
    });
  },

  getCartTVV_view: (params: any): Promise<IPagingResponse<any>> => {
    return axiosClient.post(`/abe/cart-order/tvv/get-list`, params);
  },

  deleteCartTVV: (id: number) => {
    const listID = { list_id_detail: [id] };
    return axiosClient.post(
      `/abe/cart-order/tvv/delete-cart-order-detail`,
      listID,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
  },

  sendApproveProductToStore: (data: any) => {
    return axiosClient.post(
      '/abe/cart-register/approve-product-to-store',
      data
      // {
      //   headers: {
      //     'Content-Type': 'application/json',
      //   },
      // }
    );
  },

  createCartTVV: (params?: CartTVVRequest) => {
    return axiosClient.post(`/abe/cart-order/tvv`, params);
  },

  requestApprovalToCHT: (cart_order_tvv_id: number, capital_year?: number) => {
    return axiosClient.post(`/abe/cart-order/tvv/request-approval-to-cht`, {
      cart_order_tvv_id,
      ...(capital_year ? { capital_year } : {}),
    });
  },

  requestApprovalToBranch: (id: number, capital_year?: number) => {
    return axiosClient.post(`/abe/cart-order/cht/request-approval-to-branch`, {
      id,
      ...(capital_year ? { capital_year } : {}),
    });
  },

  updateProductCart: (params: any) => {
    return axiosClient.put(`abe/cart-order/tvv`, params);
  },

  getCartCHT_view: (params: any): Promise<IPagingResponse<any>> => {
    return axiosClient.post(`/abe/cart-order/cht/get-list`, params);
  },

  getCartBranch_view: (params: any): Promise<IPagingResponse<any>> => {
    return axiosClient.get(`/abe/cart-order-branch/list_details`, { params });
  },

  getListOrderShop: (params: any): Promise<IPagingResponse<any>> => {
    return axiosClient.get(`/abe/cart-order/branch/get-list-order-shop`, {
      params,
    });
  },

  updateStatusListCart_CHT: (params: any): Promise<IPagingResponse<any>> => {
    return axiosClient.post(
      `abe/cart-order/branch/update_status_list_cart_cht`,
      params
    );
  },

  updateStatusCart_CHT: (params: any): Promise<IPagingResponse<any>> => {
    return axiosClient.post(
      `abe/cart-order/branch/aprove-cart-order-cht`,
      params
    );
  },

  updateStatusCart_Brand: (params: any): Promise<IPagingResponse<any>> => {
    return axiosClient.post(
      `abe/cart-order/branch/aprove-cart-order-branch`,
      params
    );
  },

  deleteCartCHT: (id: number, listId: number[], is_delete_all: boolean) => {
    const param = {
      cart_order_cht_id: id,
      list_cart_order_cht_dt_ids: listId,
      is_delete_all: is_delete_all,
    };
    return axiosClient.post(
      `/abe/cart-order/cht/delete-cart-order-detail`,
      param
    );
  },

  updateProductCHT: (data: any) => {
    return axiosClient.put(`/abe/cart-order/cht`, data);
  },

  getCartOrderTVV: (shopId: any): Promise<any> => {
    return axiosClient.get(`/abe/cart-order-tvv?shop_id=${shopId}`);
  },

  checkValidate: (
    id: number
  ): Promise<{ data: any; status: string; message: string }> => {
    return axiosClient.get(`/abe/cart-order-tvv/validate/${id}`);
  },

  getTvvToReject: (shopId: any, cart_register_id: number) => {
    return axiosClient.get(
      `abe/cart-order/cht/get-list-cart-tvv-for-reject?shop_id=${shopId}&cart_register_id=${cart_register_id}`
    );
  },

  rejectCartTvv: (data: any) => {
    return axiosClient.post(`abe/cart-order/cht/reject-cart-order-tvv`, data);
  },

  getProductTvvDetail: (
    code: string,
    params?: IPagination
  ): Promise<IPagingResponse<IProduct>> => {
    return axiosClient.get(
      `abe/cart-register/get-detail?id_cart_register_detail=${code}`,
      {
        params,
      }
    );
  },

  checkValidateCHT: (
    id: any
  ): Promise<{
    data: any;
    coda: any;
    status: string;
    message: string;
  }> => {
    return axiosClient.get(`/abe/cart-order/cht/validate/${id}`);
  },

  rejectCartOrderCHT: (cart_order_cht_id: number) => {
    return axiosClient.post(`/abe/cart/reject-cart-order-cht`, {
      cart_order_cht_id,
    });
  },

  getMinMaxQuantityCartOrderTVV: (
    cart_code: string,
    capital_year?: number | null
  ): Promise<IPagingResponse<any>> => {
    const params: Record<string, any> = { cart_code };
    if (capital_year !== undefined && capital_year !== null) {
      params.capital_year = capital_year;
    }
    return axiosClient.get(
      `/abe/cart-order/tvv/get-min-max-quantity-cart-order`,
      {
        params,
      }
    );
  },

  getPair: (cart_register_detail_id: number) => {
    return axiosClient.get(
      `abe/cart-register/get-pair/${cart_register_detail_id}`
    );
  },

  getPack: (cart_register_detail_id: number) => {
    return axiosClient.get(
      `abe/cart-register/get-pack/${cart_register_detail_id}`
    );
  },

  getCartChiNhanh: (
    plant_id: number,
    params?: IPagination
  ): Promise<ICartListResponse> => {
    return axiosClient.get(`/abe/cart-register/get-cart-by-plant/${plant_id}`, {
      params,
    });
  },

  getProductOfCartChiNhanh: (
    params?: any
  ): Promise<IPagingResponse<IProduct>> => {
    return axiosClient.get(`/abe/cart-register/list-data-by-cart-code`, {
      params,
    });
  },
  getCartOrderAllBranch: (params: any): Promise<IPagingResponse<any>> => {
    return axiosClient.post(`/abe/cart-order/branch/get-list`, params);
  },

  getCartByPlantIdAndCartId: (plantId: string, cartRegisterId: string) => {
    return axiosClient.get(
      `/abe/cart-register/get-cart-by-plant/${plantId}/details/${cartRegisterId}`
    );
  },

  exportMultiStore: (param: any) => {
    return axiosClient.post(`abe/cart-order/export-multiple-store`, {
      store_ids: param?.listShop,
      cart_code: param?.cart_code,
    });
  },

  exportDonHangDangKy: (param: any) => {
    return axiosClient.post(`abe/cart-order/export-don-hang-dang-ky`, param);
  },

  exportVon: (param: any) => {
    const plant_ids = param;
    return axiosClient.post(`abe/cart-order/export-von`, { plant_ids });
  },

  exportKhaiBaoVon: (param: any) => {
    const codes = param;
    return axiosClient.post(`abe/cart-order/export-khai-bao-von`, { codes });
  },

  exportKhaiBaoTu: (param: any) => {
    const cart_register_id = param;
    return axiosClient.post(
      `abe/cart-order/export-khai-bao-tu`,
      cart_register_id
    );
  },

  exportTheoDoiDangKy: (param: any) => {
    const codes = param;
    return axiosClient.post(`abe/cart-order/export-theo-doi-dang-ky`, codes);
  },

  getlogApprove: (id: any): Promise<any> => {
    return axiosClient.get(
      `abe/cart-order/list-log-approve-cht?cart_order_cht_id=${id}&order_by=created_at&order_type=DESC`
    );
  },

  importCartRegister: (params?: any) => {
    return axiosClient.post(`/abe/cart-order/tvv/import-cart-register`, params);
  },
};

export default CartApi;
